import { IconButton } from 'components/Button/IconButton';
import { HatchingEgg } from 'icons/hatching-egg';
import React from 'react';
import cardStyles from './../PreviewCard.module.scss';
import styles from './NoCardSelected.module.scss';
import cls from 'classnames';

export function NoCardSelected() {
  return (
    <div className={cls(cardStyles.cardBorder)}>
      <div className={cls(cardStyles.previewCard, styles.noCardSelected)}>
        <div className={styles.icon}>
          <IconButton icon={<HatchingEgg />} rounded square />
        </div>
        <p className={cls('subheading-default', styles.textCenter)}>
          Select the egg you want to hatch
        </p>
      </div>
    </div>
  );
}
